import {Auth} from '@aws-amplify/auth'
import {PagoLoanCalculation, PagoLoanOptions} from '@festi/common/api/rest'
import {KycApiAnswer} from '../PagoContext'

export default async function pagoFetch(path: string, query?: string) {
  return await fetch(
    query
      ? `https://api.pagopayments.is/v1/${path}?${query}`
      : `https://api.pagopayments.is/v1/${path}`,
  ).then((res) => {
    if (res.status === 404) {
      throw res.status
    }

    return res.json()
  })
}

export async function pagoTermsAndConditions() {
  return pagoFetch('terms-and-conditions')
}

export const pagoLoanCalculations = async (
  price: number,
  loanInstallments: number,
): Promise<PagoLoanCalculation> => {
  return pagoFetch(
    'loan/calculation',
    `amount=${price}&installments=${loanInstallments}`,
  )
}

export const pagoInstallmentsOptions = async (
  price: number,
): Promise<PagoLoanOptions> => {
  return pagoFetch(`loan/options`, `amount=${price}`)
}

export const paymentGatewayFetch = async (
  url: string,
  method: 'GET' | 'POST',
  body?: Record<string, string | boolean | number | KycApiAnswer[]>,
) => {
  const session = await Auth.currentSession()
  const idToken = session.getIdToken().getJwtToken()

  return fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `CognitoJWT ${idToken}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  }).then((res) => res.json())
}
